import { useState } from "react"

const InsertPreview = ({insertQuantity, insertName, thumbnailImagePath, fullScreenImagePath}) => {
    const [notImageFound, setNotImageFound] = useState(false)

    return (
        <div className={`rounded-lg bg-gray-100 w-40 ${insertName ? "h-56" : "h-48"} flex flex-col ${notImageFound ? "cursor-default" : "cursor-pointer"}`}>
            <div className='rounded-lg bg-white border p-1 flex justify-center h-5/6'>

                {notImageFound && <div className="flex flex-col justify-center text-red-500 text-2xl font-bold">{'Sin imagen'}</div>}

                {!notImageFound && (
                    <img
                        src={thumbnailImagePath}
                        alt="Insert preview"
                        onError={() => setNotImageFound(true)}
                        onClick={() => window.open(fullScreenImagePath, "_blank")}
                    />
                )}
            </div>
            <div className='text-center font-medium pt-1 h-4'>
                {`${insertQuantity} ${insertQuantity > 1 ? "piezas" : "pieza"}`}
            </div>
            {/* Which insert it is: brands ship boxes, flyers and promo samples that look alike in a thumbnail. */}
            {insertName && (
                <div className='text-center text-sm px-1 pt-2 truncate' title={insertName}>
                    {insertName}
                </div>
            )}
        </div>
    )
}

export default InsertPreview